import { useMemo } from "react";

import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";

const DatagridTooltipProvider = ({ children }) => {
  const theme = useTheme();

  const tooltipTheme = useMemo(
    () =>
      createTheme(theme, {
        components: {
          MuiTooltip: {
            defaultProps: {
              placement: "top",
              arrow: false,
            },
            styleOverrides: {
              tooltip: {
                backgroundColor: theme.palette.secondary.contrastText,
                color: theme.palette.secondary.main,
                border: `2px solid ${theme.palette.secondary.main}`,
                borderRadius: "0.25rem",
                fontSize: "0.75rem",
                fontWeight: 700,
                lineHeight: 1.4,
                padding: "4px 10px",
                boxShadow: theme.shadows[2],
              },
              arrow: {
                display: "none",
              },
            },
          },
        },
      }),
    [theme],
  );

  return <ThemeProvider theme={tooltipTheme}>{children}</ThemeProvider>;
};

export default DatagridTooltipProvider;
